import React from 'react';
import * as PopoverPrimitive from '@radix-ui/react-popover';

import { StyledPopoverRoot, StyledPopoverWrapper } from './styles';

export type PopoverProps = React.ComponentProps<typeof PopoverPrimitive.Root>;

export const Popover: React.FC<PopoverProps> = ({ children, ...props }) => {
  return <StyledPopoverRoot {...props}>{children}</StyledPopoverRoot>;
};

export type PopoverWrapperProps = PopoverPrimitive.PopoverContentProps &
  React.ComponentProps<typeof StyledPopoverWrapper>;

export const PopoverWrapper: React.FC<PopoverWrapperProps> = ({
  children,
  ...props
}) => {
  return (
    <StyledPopoverWrapper side="right" className="PopoverContent" {...props}>
      {children}
      <PopoverPrimitive.Arrow className="PopoverArrow" />
    </StyledPopoverWrapper>
  );
};

export const PopoverTrigger = PopoverPrimitive.Trigger;
